<template>
  <div class="text-center">
    <v-btn text class="mr-4 mb-4" @click="$router.go(-1)">{{
      $t("button.back")
    }}</v-btn>
    <v-btn
      v-if="itemPendingValidation"
      color="error"
      class="mr-4 mb-4"
      @click.stop="rejectDialog = true"
      :disabled="itemNotAssigned"
    >
      <v-icon left>mdi-thumb-down</v-icon>
      {{ $t("button.reject") }}
    </v-btn>
    <v-btn
      v-if="itemPendingValidation"
      color="success"
      class="mr-4 mb-4"
      @click="accept"
      :disabled="itemNotAssigned"
      >
        <v-icon left>mdi-thumb-up</v-icon>
        {{ $t("button.validate") }}
    </v-btn>
    <v-btn
      v-if="itemNotAssigned"
      color="primary"
      class="mr-4 mb-4"
      @click="assignSupervisor"
      :disabled="!itemNotAssigned"
      >
        <v-icon left>mdi-thumb-up</v-icon>
        {{ $t("button.assignSupervisor") }}
    </v-btn>

    <v-dialog v-model="rejectDialog" max-width="650">
      <v-card>
        <v-card-title class="headline">{{
          $t("forms.rejectComment")
        }}</v-card-title>

        <v-card-text>
          <v-textarea
            v-model="item.reject_comment"
            required
            outlined
            hide-details
            placeholder="Insert here the comment..."
          ></v-textarea>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="rejectDialog = false">
            {{ $t("button.close") }}
          </v-btn>
          <v-btn color="error darken-1" @click="reject">
            {{ $t("button.reject") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    item: Object,
    object_type: String,
    object_id: String,
    state: String,
    form_name: String,
    supervisor: String
  },
  data: () => ({
    rejectDialog: false
  }),

  computed: {
    itemNotAssigned() {
      return this.state === "PA";
    },
    itemPendingValidation() {
      return this.state === "PV";
    },
    validItem() {
      return this.state === "VD";
    },
    processedItem() {
      return this.state === "PC";
    },
    rejectedItem() {
      return this.state === "RJ";
    }
  },

  methods: {
    accept() {
      let path =
        this.$store.state.endpoint +
        "/moderatedOperations/review/" +
        this.object_type +
        "/validate/" +
        this.$route.params.id;
      let form_trname = `forms.titles.${this.form_name}`
      axios
        .patch(path)
        .then(response => {
          this.$store.commit("alert", {
            color: "success",
            text: this.$t("forms.validate", [this.$t(form_trname)])
          });
          this.$router.push(
            "/manage/forms/process/" +
              this.object_type +
              "/" +
              this.form_name +
              "/" +
              this.$route.params.id
          );
        })
        .catch(error => {
          console.log(error);
          console.log(error.response)
          this.$store.commit("alert", {
            color: "error",
            text:
              "An error occurred while validating the " +
              this.object_type +
              " form"
          });
        });
    },

    reject() {
      let path =
        this.$store.state.endpoint +
        "/moderatedOperations/review/" +
        this.object_type +
        "/reject/" +
        this.$route.params.id;
      let data = {
        reject_comment: this.item.reject_comment
      };
      let form_trname = `forms.titles.${this.form_name}`
      axios
        .patch(path, data)
        .then(response => {
          this.$store.commit("alert", {
            color: "success",
            text: this.$t("forms.reject", [this.$t(form_trname)])
          });
          this.$router.push("/manage/forms");
        })
        .catch(error => {
          console.log(error);
          this.$store.commit("alert", {
            color: "error",
            text:
              "An error occurred while rejecting the " +
              this.object_type +
              " form"
          });
        });
      this.rejectDialog = false;
    },

    assignSupervisor() {
      let path =
        this.$store.state.endpoint +
        "/moderatedOperations/review/" +
        this.object_type +
        "/assignSupervisor/" +
        this.$route.params.id;
      axios
        .patch(path)
        .then(response => {
          this.$emit(
            "change-state-supervisor",
            response.data.state,
            response.data.supervisor
          );
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>
